enum IconBlockNotePresentation {
	TEXTE = 'Text',
	GRAPHIQUE = 'ChartColumnIncreasing',
	TABLEAU = 'Table2',
	CHAMP_LIBRE = 'NotebookPen',
	RATIO = 'RemoveFormatting',
	AUTRE = 'CircleHelp',
}

export default IconBlockNotePresentation;
